import type { ReactNode } from 'react';
import { SkipLink } from '../../../components/SkipLink';
import { BillingNoticeBanner } from '../../billing/BillingNoticeBanner';
import './DashboardLayout.css';

interface DashboardLayoutProps {
  children: ReactNode;
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  return (
    /*
     * A column holding an optional banner above the sidebar-and-content row. The row used to be
     * the outer element; it was wrapped rather than changed so the five shells that render this
     * component keep the same `.dashboard-layout` they style against.
     */
    <div className="dashboard-shell">
      {/*
       * Lives here rather than in App so it only appears on screens that
       * actually have a sidebar to skip past, and so it stays the first thing
       * in the tab order on all four layouts that wrap in this component.
       */}
      <SkipLink />

      {/*
       * Renders nothing at all for a coach, for an organization with nothing owing, and for anyone
       * whose notice is put away. It reports its own height to the shell so the sidebar, which is
       * sticky and viewport-height, stops at the bottom of the window rather than below it.
       */}
      <BillingNoticeBanner />

      <div className="dashboard-layout">{children}</div>
    </div>
  );
};
